<template>
    <v-list-item :to="{ name: 'N_Venting gas' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-gas-cylinder</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title><v-icon small>mdi-timer-sand</v-icon> Venting gas</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemVentingGas',
    props: {
        disabled: Boolean,
    }
}
</script>